module.exports = __webpack_public_path__ + "img/footer-logo.f8cc0186.png";